module.exports = __webpack_public_path__ + "wxMicroService/img/Blp_cardbg@2x.976caba5.png";